import React, { useState, useEffect } from 'react'
import {
  Button,
  IconArrowRight,
  IconArrowLeft,
  // IconProgram,
  ToolTipInfo,
  useWindowDimensions,
  IconRepeat,
  IconLoad,
  IconTime,
  IconEdit
} from '@Knowledge-OTP/znk-ui-components'
import moment from 'moment'
import reScheduleLessonFromAdmin from '../../../../Model/Lessons/ReScheduleLessonFromAdmin'
import { useDispatch, useSelector } from 'react-redux'
import { gql, useApolloClient} from '@apollo/client'
import useTranslation from '../../../../i18n/useTranslation'
import CancelMultipleLessons from '../../modal/CancelMultipleLessons'
import SetPendingMultipleLessons from '../../modal/SetPendingMultipleLessons'
import CalendarLesson from '../../Components/CalendarLesson/index'
import CancelLesson from '../../modal/CancelLesson'
import useCalendar from './useCalendar'
import List from '../List'
import './index.css'
import ViewToggle from '../../../../common/ViewToggle'
import SelectionActionBar from '../../../../common/SelectionActionBar'
import { ReactComponent as IconRemove } from '../../../../assets/IconRemove.svg'

const CalendarSection = (props) => {
  const { lessons, week, setWeek, from, to, refetchCalendarQuery, upcomming, loading, openSideLeft } = props
  const {breakWidth} = useWindowDimensions()
  const {parseLesson} = useCalendar()
  const dispatch = useDispatch()
  const { translate } = useTranslation()
  const zone = useSelector((state) => state.timezone.zone)
  const [showCalendar] = useState(true)

  const reloadCalendar = () => {
    if (!loading && refetchCalendarQuery) refetchCalendarQuery()
  }

  const services = useSelector((state) => state.user.services)
  const orientation = services?.find((serv) => serv.isOrientation)

  // MUTACIÓN PARA REAGENDAR LECCIÓN
  const { submit: rescheduleSubmit } = reScheduleLessonFromAdmin(
    (result, { startDate: newTime, lessonId: draggableId, oldDataLesson }) => {
      if (result?.data?.reScheduleLessonFromAdmin?.hasOccurrences) {
        const ocu = result?.data?.reScheduleLessonFromAdmin?.occurrencesList
        // mostrar confirmación de agendamiento
        dispatch({
          type: 'SET_DATA_MODAL_FORM_LIST',
          payload: 'lesson.confirmDropRescheduled',
          data: {
            isOpen: true,
            collissionKinds: ocu[0].collissionKinds,
            confirmAction: () => {
              setLessonsCalendarArray(lessonsCalendarArray.map((lesson) => {
                if (lesson.idLesson === oldDataLesson.idLesson) return oldDataLesson
                return lesson
              }))
            }, // UNDO
            cancelAction: () => {
              // EJECUTA LA MUTACIÓN
              rescheduleSubmit({
                startDate: newTime,
                lessonId: draggableId,
                ignoreEducatorUnavailability: true,
                oldDataLesson
              })
            } // SCHEDULED ANYWAY
          }
        })
      } else {
        // mostrar alerta de agendamiento exitoso
      }
    }, (e, oldDataLesson) => {
      console.error(e)
      setLessonsCalendarArray(lessonsCalendarArray.map((lesson) => {
        if (lesson.idLesson === oldDataLesson.idLesson) return oldDataLesson
        return lesson
      }))
    }
  )

  const [lessonsSelected, setLessonsSelected] = useState([])
  const selectedLessonData = lessonsSelected
    .map((id) => lessons?.find((lesson) => lesson.id === id || lesson.idLesson === id))
    .filter(Boolean)
  const getTopic = (lesson) => lesson?.individualTopic || lesson?.planTopic || lesson?.groupTopic || {}
  const canEditTogether = selectedLessonData.length === 1 || (selectedLessonData.length > 1 && selectedLessonData.every((lesson) => {
    const first = selectedLessonData[0]
    const topic = getTopic(lesson)
    const firstTopic = getTopic(first)
    return lesson?.service?.id && lesson.service.id === first?.service?.id && topic?.id && topic.id === firstTopic?.id
  }))
  const startBulkEdit = () => {
    if (!canEditTogether) return
    dispatch({
      type: 'SET_DATA_MODAL_FORM_LIST',
      payload: 'lesson.editLessonModal',
      data: {
        isOpen: true,
        dataLesson: selectedLessonData[0],
        selectedLessons: selectedLessonData,
        refetch: () => refetchCalendarQuery?.()
      }
    })
  }

  const appendLessonToSelected = (id) => {
    setLessonsSelected(lessonsSelected.concat([id]))
  }
  const removeLessonFromSelected = (id) => {
    setLessonsSelected(
      lessonsSelected.reduce(
        (newArray, idLesson) => {
          if (idLesson !== id) newArray.push(idLesson)
          return newArray
        }, []
      )
    )
  }
  const lessonsSelectedHasInProgress = () => {
    //retorn true cuando alguna de las lecciones seleccionadas en lessonsSelected está en proceso
    return lessonsSelected.reduce((bool, idLesson) => {
      let lesson = lessons.find((lesson) => lesson.id === idLesson)
      if(!lesson) return bool
      return bool || (moment(lesson?.startDate) < moment() && moment() < moment(lesson?.endDate))
    }, false) 
  }

  const SetMultipleLessonsInPending = (lessons) => {
    if (lessons.length === 1) {
      dispatch({
        type: 'SET_DATA_MODAL_FORM_LIST',
        payload: 'plan.setPendingLesson',
        data: {
          isOpen: true,
          lessonId: lessons[0] || ''
        }
      })
    } else {
      dispatch({
        type: 'SET_DATA_MODAL_FORM_LIST',
        payload: 'lesson.setPendingMultiple',
        data: {
          isOpen: true,
          lessonsId: lessons
        }
      })
    }
  }

  const RemoveMultipleLessons = (lessons) => {
    if (lessons.length === 1) {
      dispatch({
        type: 'SET_DATA_MODAL_FORM_LIST',
        payload: 'plan.cancelLesson',
        data: {
          isOpen: true,
          lessonId: lessons[0] || ''
        }
      })
    } else {
      dispatch({
        type: 'SET_DATA_MODAL_FORM_LIST',
        payload: 'lesson.cancelMultiple',
        data: {
          isOpen: true,
          lessonsId: lessons
        }
      })
    }
  }

  const [lessonsCalendarArray, setLessonsCalendarArray] = useState([])

  useEffect(() => {
    if (lessons && orientation?.id) setLessonsCalendarArray(parseLesson(lessons, orientation.id, upcomming))
    // eslint-disable-next-line
  }, [lessons, orientation])

  useEffect(() => {
    if (lessonsSelected.length === 1) {
      const isGroupLesson =
        lessonsCalendarArray.filter(
          (lesson) => lesson.idLesson === lessonsSelected[0]
        )[0]?.isGroup
      // si la primera lección seleccinada es grupal
      // => solo puedo continuar seleccionando grupales
      // si es individual => solo puedo continuar seleccionando individuales
      setLessonsCalendarArray(
        lessonsCalendarArray.map(
          (lesson) => {
            if (lesson?.isGroup) lesson.canChecked = isGroupLesson
            else lesson.canChecked = !isGroupLesson
            return lesson
          }
        )
      )
    } else if (lessonsSelected.length === 0 && lessonsCalendarArray.length > 0) {
      // todos se pueden seleccionar
      setLessonsCalendarArray(
        lessonsCalendarArray.map(
          (lesson) => {
            lesson.canChecked = true
            return lesson
          }
        )
      )
    }
    // eslint-disable-next-line
  }, [lessonsSelected]) 

  const client = useApolloClient()

  const parseFreeFramesToBlocks = (frames) => {
    let freeBlocks = []
    frames.forEach((fr) => {
      let [from, to] = fr
      from = moment(from)
      to = moment(to).set({minutes: 0, seconds: 0})
      while(from < to){
        freeBlocks.push(`${from.clone().day() === 0 ? 6 : from.clone().day()-1}-${from.clone().hour()}`)
        from.add(1, 'hour')
      }
    })
    return freeBlocks
  }   
  
  return (
    <div className={`d-flex flex-column m-0 py-0 pr-0 calendar-section-shell ${openSideLeft ? 'pl-6' : 'pl-0'}`}>
      <div
        className='d-flex flex-row justify-content-between w-100 py-4' style={{
          maxHeight: '10vh',
          height: '10vh',
          width: '81%',
        }}
      >
        {
          lessonsSelected.length > 0
            ? <>
              <SelectionActionBar
                floating
                count={lessonsSelected.length}
                selection={lessonsSelected}
                label={`${lessonsSelected.length === 1
                  ? translate('lesson.multipleselection.lessonselec')
                  : translate('lesson.multipleselection.lessonsselec')}`}
                onClear={() => setLessonsSelected([])}
                actions={[
                  {
                    key: 'edit',
                    Icon: IconEdit,
                    label: 'Edit',
                    variant: 'edit',
                    disabled: !canEditTogether,
                    title: !canEditTogether ? 'Select lessons with the same service and topic to edit together.' : '',
                    onClick: startBulkEdit
                  },
                  ...(!lessonsCalendarArray.find(
                    (lesson) => lesson.idLesson === lessonsSelected[0]
                  )?.isGroup && !lessonsSelectedHasInProgress()
                    ? [{
                      key: 'pending',
                      Icon: IconTime,
                      label: translate('modal.infolesson.leavepending'),
                      variant: 'pending',
                      onClick: () => SetMultipleLessonsInPending(lessonsSelected)
                    }]
                    : []),
                  {
                    key: 'remove',
                    Icon: IconRemove,
                    label: translate('lesson.multipleselection.remove'),
                    variant: 'remove',
                    onClick: () => RemoveMultipleLessons(lessonsSelected)
                  }
                ]}
              />
              <div className='d-flex flex-row'>
                <Button className='align-self-center' onClick={() => { setWeek(0) }} style={{ width: '100px', color: '#254050', lineHeight: '22px', border: 'solid 1px #DCE1E7' }} label={translate('lessons.calendar.today').toUpperCase()} size='small' />
                <div className='week-control d-flex flex-row align-items-center px-4'>
                  <div style={{ width: '80px' }} className='d-flex flex-row justify-content-between'>
                    <ToolTipInfo
                      tooltipId={'last-week-selected'}
                      innerElement={<span className='h45 text-pause'>Last week</span>}
                      place='bottom'
                    >
                      <div className='ml-2 mr-0 my-0 hover-icon' onClick={() => setWeek(week - 1)}>
                        <IconArrowLeft size={20}/>
                      </div>
                    </ToolTipInfo>
                    <ToolTipInfo
                      tooltipId={'next-week-selected'}
                      innerElement={<span className='h45 text-pause'>Next week</span>}
                      place='bottom'
                    >
                      <div className='mx-2 mr-0 my-0 hover-icon' onClick={() => setWeek(week + 1)}>
                        <IconArrowRight size={20}/>
                      </div>
                    </ToolTipInfo>
                  </div>
                  <span className='ml-4' style={{ textTransform: 'capitalize' }}>{`${moment(from).startOf('isoWeek').format('MMMM Do')} - ${moment(from).endOf('isoWeek').format('MMMM Do')}`}</span>
                </div>
              </div>
              <div className="d-flex flex-row align-items-center px-4">
                <div
                  className='hover-icon cursor-pointer ml-3'
                  role='button'
                  tabIndex={loading ? -1 : 0}
                  aria-label='Reload calendar'
                  title='Reload calendar'
                  onClick={reloadCalendar}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault()
                      reloadCalendar()
                    }
                  }}
                >
                  {loading ? <IconLoad size={15} /> : <IconRepeat className='text-gray' size={15} />}
                </div>
                <ViewToggle className='calendar-header-toggle' />
              </div>
              </>
            : <>
              <div className='d-flex flex-row'>
                <Button className='align-self-center' onClick={() => { setWeek(0) }} style={{ width: '100px', color: '#254050', lineHeight: '22px', border: 'solid 1px #DCE1E7' }} label={translate('lessons.calendar.today').toUpperCase()} size='small' />
                <div className='week-control d-flex flex-row align-items-center px-4'>
                  <div style={{ width: '80px' }} className='d-flex flex-row justify-content-between'>
                    <ToolTipInfo
                      tooltipId={'last-week'}
                      innerElement={<span className='h45 text-pause'>Last week</span>}
                      place='bottom'
                    >
                      <div 
                        className={'ml-2 mr-0 my-0 hover-icon'}
                        onClick={() => {
                            setWeek(week - 1)
                        }}>
                        <IconArrowLeft size={20}/>
                      </div>
                    </ToolTipInfo>
                    <ToolTipInfo
                      tooltipId={'next-week'}
                      innerElement={<span className='h45 text-pause'>Next week</span>}
                      place='bottom'
                    >
                      <div 
                        className={'mx-2 mr-0 my-0 hover-icon'}
                        onClick={() => {
                          setWeek(week + 1)
                        }}
                      >
                        <IconArrowRight size={20}/>
                      </div>
                    </ToolTipInfo>
                  </div>
                  <span className='ml-4' style={{ textTransform: 'capitalize' }}>{`${moment(from).startOf('isoWeek').format('MMMM Do')} - ${moment(from).endOf('isoWeek').format('MMMM Do')}`}</span>
                </div>
                </div>
                <div className="d-flex flex-row align-items-center px-4">
                  <div
                    className='hover-icon cursor-pointer ml-3'
                    role='button'
                    tabIndex={loading ? -1 : 0}
                    aria-label='Reload calendar'
                    title='Reload calendar'
                    onClick={reloadCalendar}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault()
                        reloadCalendar()
                      }
                    }}
                  >
                    {loading ? <IconLoad size={15} /> : <IconRepeat className='text-gray' size={15} />}
                  </div>
                  <ViewToggle className='calendar-header-toggle' />
                </div>
              {/**<div className='d-flex flex-row px-4'>
                <IconProgram className='align-self-center mx-4' size={16} />
                <InputSelect
                  value={null}
                  style={{ width: '137px', minHeight: '34px', height: '34px' }}
                  options={[]}
                />
              </div>**/}
              </>
        }
      </div>

      {showCalendar === true ?
          (
              <CalendarLesson
                  selectedBlocks={lessonsSelected}
                  selectBlock={(idLesson) => { appendLessonToSelected(idLesson) }}
                  deselectBlock={(idLesson) => { removeLessonFromSelected(idLesson) }}
                  from={from}
                  heightColumnPx={72}
                  widthColumnPx={180}
                  verticalView={breakWidth === 'SM'}
                  lessons={lessonsCalendarArray}
                  style={
                    breakWidth === 'SM'
                        ? {}
                        : {
                          maxHeight: '90vh',
                          height: '90vh'
                        }
                  }
                  zone={zone}
                  changeTimezoneBullet={
                    <div className='m-0 p-0 d-flex flex-column text-center'>
                      <span className='h45 text-pause'>{zone}</span>
                      <span className='h45 text-gray'>{translate('lessons.calendar.clickToChange')}</span>
                    </div>
                  }
                  changeTimezoneClickAction={() => {
                    dispatch({
                      type: 'SET_DATA_MODAL_FORM_LIST',
                      payload: 'lesson.changeTimezoneModal',
                      data: {
                        isOpen: true
                      }
                    })
                  }}
                  onClickInFreeBloc={({ day, hour, fromCalendar }) => {
                    dispatch({
                      type: 'SET_DATA_MODAL_FORM_LIST',
                      payload: 'plan.newLessonModal',
                      data: {
                        isOpen: true,
                        defaultForm: {
                          repeatmonth: false,
                          repeat: false,
                          repeatweek: false,
                          timeStart: moment(fromCalendar).add(day, 'day').set({ hour: hour, minutes: 0 }).format('HH:mm'),
                          timeEnd: moment(fromCalendar).add(day, 'day').set({ hour: hour, minutes: 50 }).format('HH:mm'),
                          date: moment(fromCalendar).add(day, 'day').format('YYYY-MM-DD'),
                          paymentDate: moment().format('YYYY-MM-DD'),
                        }
                      }
                    })
                  }}
                  handleDragUpdateLesson={(env) => {
                    const { draggableId: draggableIdJSON } = env // draggableId:  id de lección a reagendar
                    if (
                        !draggableIdJSON
                    ) {
                      dispatch({
                        type: 'SET_DATA_MODAL_FORM_LIST',
                        payload: 'lesson.dragAndDropCalendar',
                        data: {isActive: false, freeFrames: []}
                      })
                      return
                    }
                  }}
                  handleDragLesson={(env) => {
                    const { draggableId: draggableIdJSON } = env // draggableId:  id de lección a reagendar
                    if (
                        !draggableIdJSON
                    ) {
                      dispatch({
                        type: 'SET_DATA_MODAL_FORM_LIST',
                        payload: 'lesson.dragAndDropCalendar',
                        data: {isActive: false, freeFrames: []}
                      })
                      return
                    }
                    const { idEducator, idStudents } = JSON.parse(draggableIdJSON)
                    client.query(
                        {
                          query: gql`
                query(
                  $involveMyself: Boolean!
                  $studentIds: [ID!]
                  $educatorUserId: ID
                  $minDurationInMinutes: Int
                  $to: DateTime!
                  $from: DateTime!
                ) {
                  myFreeTimeFrames(
                    involveMyself: $involveMyself
                    studentIds : $studentIds 
                    educatorUserId: $educatorUserId
                    minDurationInMinutes: $minDurationInMinutes
                    to: $to
                    from: $from
                  )
                }
              `,
                          variables: {
                            involveMyself: false,
                            studentIds : idStudents,
                            educatorUserId: idEducator,
                            minDurationInMinutes: 60,
                            from: from,
                            to: to
                          }
                        }
                    ).then((result) => {
                      dispatch({
                        type: 'SET_DATA_MODAL_FORM_LIST',
                        payload: 'lesson.dragAndDropCalendar',
                        data: {
                          isActive: true,
                          freeFrames: parseFreeFramesToBlocks(result?.data?.myFreeTimeFrames || [])
                        }
                      })
                    })
                  }}
                  handleDropLesson={(env) => {
                    const { destination, draggableId: draggableIdJSON, source } = env // draggableId:  id de lección a reagendar
                    if (
                        destination?.droppableId === source?.droppableId ||
                        !source ||
                        !destination ||
                        !draggableIdJSON
                    ) {
                      dispatch({
                        type: 'SET_DATA_MODAL_FORM_LIST',
                        payload: 'lesson.dragAndDropCalendar',
                        data: {isActive: false, freeFrames: []}
                      })
                      return
                    }
                    const {idLesson: draggableId} = JSON.parse(draggableIdJSON)
                    const [isoString, day, hour] = destination.droppableId.split('&')
                    // day es un string numerico entre el 0 y 6, 0 es Lunes y 6 Domingo
                    const newTime = moment(isoString).tz(zone).startOf('isoWeek')
                        .isoWeekday(parseInt(day) + 1).hour(hour).toISOString()
                    const oldDataLesson = lessonsCalendarArray.find((lesson) => lesson.idLesson === draggableId)
                    // EVITA QUE EL BLOQUE VUELVA A SU POSICIÓN ORIGINAL MIENTRAS SE EJECUTA LA MUTACIÓN
                    setLessonsCalendarArray(lessonsCalendarArray.map((lesson) => {
                      if (lesson.idLesson === draggableId) {
                        return {
                          ...lesson,
                          hour: parseInt(hour),
                          day: parseInt(day),
                          loading: true
                        }
                      }
                      return lesson
                    }))
                    dispatch({
                      type: 'SET_DATA_MODAL_FORM_LIST',
                      payload: 'lesson.dragAndDropCalendar',
                      data: {isActive: false, freeFrames: []}
                    })

                    // EJECUTA LA MUTACIÓN
                    rescheduleSubmit({
                      startDate: newTime,
                      lessonId: draggableId,
                      ignoreEducatorUnavailability: false,
                      oldDataLesson
                    })

                  }}
                  loading={loading}
              />
          ):
          <List lessons={lessonsCalendarArray} loading={loading}/>
      }
      <CancelMultipleLessons
        refetchCalendarQuery={refetchCalendarQuery}
        setLessonsSelected={setLessonsSelected}
      />
      <CancelLesson
        refetch={() => {refetchCalendarQuery()}}
        setLessonsSelected={setLessonsSelected}
        lessonsSelected={lessonsSelected} />
      <SetPendingMultipleLessons
        refetchCalendarQuery={refetchCalendarQuery}
        setLessonsSelected={setLessonsSelected}
      />
    </div>
  )
}

export default CalendarSection
